import { ChallengeLabStatus } from '@/src/types/JamChallengeDetails';
import React from 'react';
import ChallengeLabStatusIcon from './ChallengeLabStatusIcon';
import styles from './ChallengeSidebarLabel.module.scss';

interface ChallengeSidebarLabelProps {
  title: string;
  /** Derived lab status; no icon is rendered when omitted. */
  status?: ChallengeLabStatus;
  /** Custom trailing node (e.g. the locked indicator). Takes precedence over `status`. */
  statusNode?: React.ReactNode;
}

/** Sidebar row label for a challenge: title on the left, status pinned to the right. */
const ChallengeSidebarLabel: React.FC<ChallengeSidebarLabelProps> = ({ title, status, statusNode }) => {
  const trailing = statusNode ?? (status ? <ChallengeLabStatusIcon status={status} /> : null);

  return (
    <span className={styles.root}>
      <span className={styles.title}>{title}</span>
      {trailing && (
        <span className={styles.status} data-testid="challenge-sidebar-label-status">
          {trailing}
        </span>
      )}
    </span>
  );
};

/**
 * The label as a SideNavigation `expandable-link-group` `text`. Cloudscape types `text` as string
 * and its group header drops `info`, but renders `text` as a child node, so this is the only way to
 * add a trailing status. Breaks if Cloudscape starts treating `text` as a string (see MyJamSidebar.spec).
 */
export const challengeSidebarNavText = (props: ChallengeSidebarLabelProps): string =>
  (<ChallengeSidebarLabel {...props} />) as unknown as string;

export default ChallengeSidebarLabel;
